import React, { useState } from 'react';
import { FilterState,filter,FilterDataStructure } from './Products';
import SideBarFilterCheckbox from './SideBarFilterCheckbox';
// Define the props interface, if your component accepts props
interface SidebarProps {
  // Define your prop types here
  text: string;
  filtersState: FilterState;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedFilters: number[]
};
// Functional component
const Sidebar: React.FC<SidebarProps> = ({ text,filtersState,handleChange,selectedFilters }) => {



  // You can add your component logic here
  //console.log(filtersState);
  const [addClass, setAddClass] = useState ({
    openTrigger: " close",
    elmOpen: " d-block",
    elmClose: " d-none"

})
const handlerOpen = () => {
    setAddClass({openTrigger: " open", elmOpen: " d-none", elmClose: " d-block"});
}
const handlerClose = () => {
    setAddClass({openTrigger: " close", elmOpen: " d-block", elmClose: " d-none"});
}

  return (
    <aside className={"sidebar" + addClass.openTrigger}>
    <div className="inner">
        <div className="filter">
          <>
          <a className={"ic_arrow" + addClass.elmOpen} onClick={handlerOpen}>Otevřít</a>
          <a className={"ic_close" + addClass.elmClose} onClick={handlerClose}>Zavřít</a>
            </>
            <ul className="category-filter">
            {filtersState.filterData.map((section, index) => (
              <div key={index}>
                <h3 className="mt-20">{section.section_name}</h3>
                <SideBarFilterCheckbox filterData={section} selectedFilters={selectedFilters} handleChange={handleChange} />
              </div>
            ))}

                


            </ul>
        </div>
    </div>
</aside>
  );
};

export default Sidebar;